<template>
    <div class="upload-img-component">
        <!-- 图片墙 START -->
        <div v-if="uploadMultiple && currentUploadType != 'video'" class="mul-img-part">
            <div class="image-part" v-for="(item,index) in mutipleImgList" :key="index" draggable="true" @dragstart="handleDragStart($event, item)" @dragover.prevent="handleDragOver($event, item)" @dragenter="handleDragEnter($event, item)" @dragend="handleDragEnd($event, item)">
                <div class="img-box">
                    <img class="img" :src="item" alt="">
                    <span class="upload-video-delete">
                        <span class="upload-img-delete" @click="handleDelete(index)">
                            <i class="el-icon-error"></i>
                        </span>
                    </span>
                </div>
                <p class="img-desc" v-if="uploadTitle">{{uploadTitle}}({{index+1}})</p>
            </div>
            <div class="image-part">
                <el-upload class="uploader-handle" multiple :action="uploadActionUrl" :data="ossParams" :show-file-list="false" list-type="picture-card" :before-upload="(file) => beforeUpload(file)" :on-change="handleChange" :on-success="(res, file) => handleSuccess(res, file)">
                    <i class="el-icon-plus"></i>
                    <span class="upload-tips">照片</span>
                </el-upload>
                <p class="img-desc" v-if="uploadTitle">{{uploadTitle}}</p>
            </div>
        </div>
        <!-- 图片墙 END -->

        <!-- 视频墙 START -->
        <div v-if="uploadMultiple && currentUploadType == 'video'" class="mul-img-part">
            <div class="image-part" v-for="(item,index) in mutipleImgList" :key="index" draggable="true" @dragstart="handleDragStart($event, item)" @dragover.prevent="handleDragOver($event, item)" @dragenter="handleDragEnter($event, item)" @dragend="handleDragEnd($event, item)">
                <div class="img-box">
                    <video class="video-box" :src="item" height="148" poster></video>
                    <span class="upload-video-actions">
                        <span class="upload-img-delete" @click="handlePlay(index)">
                            <i :class="{'el-icon-video-play': !mutipleTypeList[index],'el-icon-video-pause':mutipleTypeList[index]}"></i>
                        </span>
                    </span>
                    <span class="upload-video-delete">
                        <span class="upload-img-delete" @click="handleDelete(index)">
                            <i class="el-icon-error"></i>
                        </span>
                    </span>
                </div>
            </div>
            <div class="image-part">
                <el-upload class="uploader-handle" multiple :action="uploadActionUrl" :data="ossParams" :show-file-list="false" list-type="picture-card" :before-upload="(file) => beforeUpload(file)" :on-change="handleChange" :on-success="(res, file) => handleSuccess(res, file)">
                    <i class="el-icon-plus"></i>
                    <span class="upload-tips">视频</span>
                </el-upload>
                <p class="img-desc" v-if="uploadTitle">{{uploadTitle}}</p>
            </div>
        </div>
        <!-- 视频墙 END -->

        <!-- 单张图片 START -->
        <div v-if="!uploadMultiple && currentUploadType != 'video'" class="single-img-part">
            <div class="image-part">
                <el-upload class="uploader-handle img-box" :action="uploadActionUrl" :data="ossParams" :show-file-list="false" list-type="picture" :before-upload="(file) => beforeUpload(file)" :on-change="handleChange" :on-success="(res, file) => handleSuccess(res, file)">
                    <img v-if="singleImgUrl" :src="singleImgUrl" class="img">
                    <i class="el-icon-plus uploader-icon"></i>
                    <span v-if="!singleImgUrl" class="upload-tips">照片</span>
                </el-upload>
                <p class="img-desc" v-if="uploadTitle">{{uploadTitle}}</p>
                <span class="upload-img-delete" v-if="showSingleDelete && singleImgUrl" @click="handleSingleDelete">
                    <i class="el-icon-close"></i>
                </span>
            </div>
        </div>
        <!-- 单张图片 END -->

        <!-- 单张视频 START -->
        <div v-if="!uploadMultiple && currentUploadType == 'video'" class="single-img-part">
            <div class="image-part">
                <el-upload class="uploader-handle img-box" :action="uploadActionUrl" :data="ossParams" :show-file-list="false" list-type="picture" :before-upload="(file) => beforeUpload(file)" :on-change="handleChange" :on-success="(res, file) => handleSuccess(res, file)">
                    <video v-if="singleImgUrl" :src="singleImgUrl" height="148" class="video" controls poster></video>
                    <i v-if="!singleImgUrl" class="el-icon-plus uploader-icon"></i>
                    <span v-if="!singleImgUrl" class="upload-tips">视频</span>
                </el-upload>
                <p class="img-desc" v-if="uploadTitle">{{uploadTitle}}</p>
                <span class="upload-img-delete" v-if="showSingleDelete && singleImgUrl" @click="handleSingleDelete">
                    <i class="el-icon-close"></i>
                </span>
            </div>
        </div>
        <!-- 单张视频 END -->
    </div>
</template>
<script>
import Vue from 'vue';
export default {
    /*
        uploadMultiple: 上传文件是单个还是多个，true：多个，false或者不传 单个
        uploadType： 上传文件类型，文件传‘file’， 默认图片可不传
        dataSource：编辑时展示列表 ，string类型，多个传用，分割的字符串
        uploadPara： // OSS上传附带参数，需请求接口传过来
        uploadTitle： 图片墙的标题
    */
    props: ['uploadMultiple', 'uploadType', 'dataSource', 'uploadPara', 'uploadTitle', 'uploadSingleDelete'],
    data() {
        return {
            uploadActionUrl: process.env.API_ROOT+'common/uploadImg', //上传地址
            formData:{
              dir:"admin"
            },
            ossParams: {
                // OSS上传附带参数
                key: '',
                dir: '',
                policy: '',
                OSSAccessKeyId: '',
                success_action_status: '',
                callback: '',
                signature: ''
            },
            singleImgUrl: '',
            mutipleImgList: [],
            mutipleTypeList: [],
            currentUploadType: 'image',
            showSingleDelete: false,
            browserNameType: null,
            dragging: null
        };
    },
    watch: {
        dataSource(val) {
            if (this.uploadMultiple) {
                this.mutipleImgList = this.dataSource ? this.dataSource.split(',') : [];
                let list = [];
                if (this.mutipleImgList.length) {
                    this.mutipleImgList.forEach((value, index) => {
                        list.push(false);
                    })
                }
                this.mutipleTypeList = list;
            } else {
                this.singleImgUrl = this.dataSource;
            }
        },
        uploadPara(val) {
            if (JSON.parse(this.uploadPara)) {
                this.set_upload_param(JSON.parse(this.uploadPara));
            }
        },
        uploadType(val) {
            this.currentUploadType = val;
        }
    },
    methods: {
        handlePlay(index) {
            let ele = document.getElementsByClassName('video-box')[index];
            Vue.set(this.mutipleTypeList, index, ele.paused);
            let that = this;
            ele.onended = function () {
                Vue.set(that.mutipleTypeList, index, false);
            }
            if (ele.paused) {
                ele.play();
            } else {
                ele.pause();
            }
        },
        handleDragStart(e, item) {
            this.dragging = item;
            if (this.browserNameType.name == "FF") {
                e.dataTransfer.setData(this.dragging, item); // 火狐拖拽必须携带数据 IE偏偏不支持这个
            }
        },
        handleDragEnd() {
            this.dragging = null;
        },
        // 首先把div变成可以放置的元素，即重写dragenter/dragover
        handleDragOver(e) {
            e.dataTransfer.dropEffect = "move"; // e.dataTransfer.dropEffect="move";//在dragenter中针对放置目标来设置!
        },
        handleDragEnter(e, item) {
            if (this.dragging) {
                e.dataTransfer.effectAllowed = "move"; // 为需要移动的元素设置dragstart事件
                if (item === this.dragging) {
                    return;
                }
                const [...newItems] = this.mutipleImgList;
                const src = newItems.indexOf(this.dragging);
                const dst = newItems.indexOf(item);
                newItems.splice(dst, 0, ...newItems.splice(src, 1));
                this.mutipleImgList = newItems;
                let list = [];
                if (this.mutipleImgList.length) {
                    this.mutipleImgList.forEach((value, index) => {
                        list.push(false);
                    })
                }
                this.mutipleTypeList = list;
                this.$emit('change', this.mutipleImgList.join(','));
            }
        },
        BrowserType() {
            var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
            var isOpera = userAgent.indexOf("Opera") > -1; //判断是否Opera浏览器
            var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1 && !isOpera; //判断是否IE浏览器
            var isEdge = userAgent.indexOf("Windows NT 6.1; Trident/7.0;") > -1 && !isIE; //判断是否IE的Edge浏览器
            var isFF = userAgent.indexOf("Firefox") > -1; //判断是否Firefox浏览器
            var isSafari = userAgent.indexOf("Safari") > -1 && userAgent.indexOf("Chrome") == -1; //判断是否Safari浏览器
            var isChrome = userAgent.indexOf("Chrome") > -1 && userAgent.indexOf("Safari") > -1; //判断Chrome浏览器

            if (isIE) {
                var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
                reIE.test(userAgent);
                var fIEVersion = parseFloat(RegExp["$1"]);
                return { name: "IE", num: fIEVersion };
            }
            if (isFF) { return { name: "FF", num: "FF" }; }
            if (isOpera) { return { name: "Opera", num: "Opera" }; }
            if (isSafari) { return { name: "Safari", num: "Safari" }; }
            if (isChrome) { return { name: "Chrome", num: "Chrome" }; }
            if (isEdge) { return { name: "Edge", num: "Edge" }; }
        },
        /**
        * 生成随机字符串
        * @param filename
        * @returns {string}
        */
        random_string(len) {
            var myDate = new Date();
            var seconds = myDate.getTime();
            len = len || 32;
            var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz123456789';
            var maxPos = chars.length;
            var pwd = '';
            for (var i = 0; i < len; i++) {
                pwd += chars.charAt(Math.floor(Math.random() * maxPos));
            }
            return seconds + pwd;
        },

        /**
         * 获取文件后缀
         * @param filename
         * @returns {string}
         */
        get_suffix(filename) {
            var pos = filename.lastIndexOf('.')
            var suffix = ''
            if (pos != -1) {
                suffix = filename.substring(pos)
            }
            return suffix;
        },

        /**
         * 随机生成文件名
         * @param filename
         * @returns {string}
         */
        random_filename(filename) {
            var suffix = this.get_suffix(filename);
            var random_filename = this.random_string(10) + suffix;
            return random_filename;
        },
        // 单个上传删除
        handleSingleDelete() {
            this.singleImgUrl = '';
        },
        // 多个上传删除图片
        handleDelete(index) {
            this.mutipleImgList.splice(index, 1);
            let list = [];
            if (this.mutipleImgList.length) {
                this.mutipleImgList.forEach((value, index) => {
                    list.push(false);
                })
            }
            this.mutipleTypeList = list;
            this.$emit('change', this.mutipleImgList.join(','));
        },
        handleChange(file, fileList) {
            // 图片修改
            //随机生成文件名称
            var random_name = this.random_filename(file.name);
            this.ossParams.key = this.ossParams.dir + random_name;
        },
        handleSuccess(res, file) {
            if (this.uploadMultiple) {
                this.mutipleImgList.push(res);
                let list = [];
                if (this.mutipleImgList.length) {
                    this.mutipleImgList.forEach((value, index) => {
                        list.push(false);
                    })
                }
                this.mutipleTypeList = list;
                this.$emit('change', this.mutipleImgList.join(','));
            } else {
                this.singleImgUrl = res;
                this.$emit('change', this.singleImgUrl);
            }
        },
        beforeUpload(file) {
            let upload = true;
            // 是否是允许上传的文件类型
            let isAllowFile = null;
            let isAllowMsg = '';
            if (this.currentUploadType == 'video') {
                isAllowFile = file.type === 'video/mp4';
                isAllowMsg = '只能上传mp4格式视频'
            } else {
                isAllowFile = file.type === 'image/png' || file.type === 'image/jpeg';
                isAllowMsg = '只能上传png、jpg格式图片';
            }
            let isLt2M = file.size / 1024 / 1024 < 10;
            if (!isAllowFile) {
                upload = false;
                this.$message.error(isAllowMsg);
            }
            if (!isLt2M) {
                upload = false;
                this.$message.error("只能上传大小不能超过10MB的文件");
            }
            return upload;
        },
        // uploadFileBridge() {
        //     this.$api.uploadFileBridge({
        //         token: this.$store.state.token,
        //         dir: "TMS/wl/"
        //     }).then(res => {
        //         this.set_upload_param(res.data);
        //     }).catch(res => {
        //         console.log(res.msg);
        //     });
        // },
        set_upload_param(data) {
          this.formData.dir = data.dir;
            // this.uploadActionUrl = data.host;
            // this.ossParams.dir = data.dir;
            // this.ossParams.policy = data.policy;
            // this.ossParams.OSSAccessKeyId = data.accessid;
            // this.ossParams.success_action_status = "200"; //让服务端返回200,不然，默认会返回204
            // this.ossParams.callback = data.callback;
            // this.ossParams.signature = data.signature;
        },
    },
    mounted() {
        this.browserNameType = this.BrowserType();
        this.currentUploadType = this.uploadType || 'image';
        if (!this.uploadActionUrl) {
            this.set_upload_param(JSON.parse(this.uploadPara))
        }
        if (this.uploadMultiple) {
            this.mutipleImgList = this.dataSource ? this.dataSource.split(',') : [];
        } else {
            this.singleImgUrl = this.dataSource;
        }
        this.showSingleDelete = this.uploadSingleDelete || false;
    },
};
</script>
<style lang="scss" src="./index.scss"></style>



// WEBPACK FOOTER //
// src/components/upload/index.vue